import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import { RESET_PASSWORD_PATH } from "utils/constants/paths";

const ResetPassword = Loadable(React.lazy(() => import("./View")));

export const ResetPasswordRoute: IRouteItem = {
  path: RESET_PASSWORD_PATH,
  iconName: "",
  element: React.createElement(ResetPassword),
  showInDrawer: false,
};
